import { render, staticRenderFns } from "./SearchParentsItem.vue?vue&type=template&id=85cc1172&scoped=true&"
import script from "./SearchParentsItem.vue?vue&type=script&lang=js&"
export * from "./SearchParentsItem.vue?vue&type=script&lang=js&"
import style1 from "./SearchParentsItem.vue?vue&type=style&index=1&id=85cc1172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cc1172",
  null
  
)

export default component.exports